import { useEffect, useState } from "react";
import type { CommissionEditRequestStatusFilter } from "@/hooks/queries/useCommissionEditRequests";
import { useIsMobile } from "@/hooks/useIsMobile";
import type { CommissionEditQueueViewMode } from "../commissionEditQueue.constants";
import type { RequestContext } from "../commissionEditQueue.types";

export function useCommissionEditQueueState() {
  const [viewMode, setViewMode] = useState<CommissionEditQueueViewMode>("table");
  const [statusFilter, setStatusFilter] =
    useState<CommissionEditRequestStatusFilter>("all");
  const [typeFilter, setTypeFilter] = useState("__all__");
  const [search, setSearch] = useState("");
  const [selectedContext, setSelectedContext] = useState<RequestContext | null>(null);
  const [rejectingId, setRejectingId] = useState<number | null>(null);
  const [rejectNote, setRejectNote] = useState("");
  const isMobile = useIsMobile();

  useEffect(() => {
    if (isMobile) setViewMode("grid");
  }, [isMobile]);

  function resetRejection() {
    setRejectingId(null);
    setRejectNote("");
  }

  function closeSelected() {
    setSelectedContext(null);
    resetRejection();
  }

  return {
    viewMode,
    setViewMode,
    statusFilter,
    setStatusFilter,
    typeFilter,
    setTypeFilter,
    search,
    setSearch,
    selectedContext,
    setSelectedContext,
    rejectingId,
    setRejectingId,
    rejectNote,
    setRejectNote,
    resetRejection,
    closeSelected,
  };
}
